(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/components/navigation-menu/views/hamburger-icon.js') >= 0) return;  svs.modules.push('/components/components/navigation-menu/views/hamburger-icon.js'); (function(svs, Handlebars) {
_svs=window.svs=window.svs||{};
_cmps=_svs.components=_svs.components||{};
_cmps.navigation_menu=_cmps.navigation_menu||{};
_cmps.navigation_menu.templates=_cmps.navigation_menu.templates||{};
svs.components.navigation_menu.templates.hamburger_icon = Handlebars.template({"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
    return container.escapeExpression((helpers.ui || (depth0 && depth0.ui) || helpers.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),"icon",{"name":"ui","hash":{"icon":(depth0 != null ? depth0.icon : depth0)},"data":data}))
    + "\n";
},"useData":true});
Handlebars.partials['components-components-navigation_menu-hamburger_icon'] = svs.components.navigation_menu.templates.hamburger_icon;
})(svs, Handlebars);

 })(window);